import { computed } from 'vue';
import { useDisplay } from 'vuetify';
import SiteHeader from './SiteHeader.vue';

function useSiteHeader() {
    const { mdAndUp, md: compactMenu } = useDisplay();
    const isMobile = computed(() => !mdAndUp.value);
    const height = computed(() => (isMobile.value ? 50 : 72));

    return {
        compactMenu,
        isMobile,
        height
    };
}

export { SiteHeader, useSiteHeader };
